import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { C } from "../../lib/api";

// Staff sign-in shown at /admin when nobody (or a non-staff player) is signed in. Signing in here swaps the session.
export const AdminLogin = ({ current }) => {
  const { login, logout } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      if (current) await logout();
      const data = await login(email.trim(), password);
      if (!C.STAFF_ROLES.includes(data.user.role)) { await logout(); setErr("That account is not staff."); }
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(d === "RATE_LIMITED" ? "Too many attempts — wait 15 minutes." : "Wrong email or password.");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 noise" data-testid="admin-login">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-amber-400/25 bg-slate-950/90 p-8 flex flex-col gap-4 shadow-[0_30px_80px_rgba(0,0,0,0.8)] rise">
        <div className="flex items-center gap-3 text-amber-200">
          <ShieldCheck className="w-6 h-6" />
          <div><div className="font-display tracking-[0.3em] text-sm">STAFF</div><div className="text-[11px] text-slate-400">Players Room control room</div></div>
        </div>
        {current && <p className="text-[11px] text-slate-400" data-testid="admin-login-current">You're signed in as <b className="text-amber-100">{current.display_name}</b> (player). Signing in below switches this tab to the staff account.</p>}
        <label className="text-xs text-slate-400">Email
          <input data-testid="admin-login-email" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-lg bg-black border border-white/10 px-3 py-2 text-sm text-amber-50 focus:border-amber-400/60 outline-none" />
        </label>
        <label className="text-xs text-slate-400">Password
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-lg bg-black border border-white/10 px-3 py-2 text-sm text-amber-50 focus:border-amber-400/60 outline-none" />
        </label>
        {err && <div data-testid="admin-login-error" className="text-xs text-red-300 bg-red-950/50 border border-red-500/30 rounded-lg px-3 py-2">{err}</div>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-gold rounded-full px-5 py-2.5 text-xs font-display tracking-wider disabled:opacity-50">{busy ? "Signing in…" : "Open dashboard"}</button>
        <a href="/" className="text-[11px] text-slate-500 hover:text-slate-300 text-center">Back to the game</a>
      </form>
    </div>
  );
};
